/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

const normalizeOption = (value) => {
    let underlyingValue;
    let label;
    if (value !== null && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'value')) {
        underlyingValue = value.value;
        label = value.label;
    } else {
        underlyingValue = value;
        label = value;
    }
    return {
        value: underlyingValue,
        label,
        ariaLabel: value?.ariaLabel,
    };
};

export default normalizeOption;
